import { Controller } from 'stimulus'

// Reopens the iubenda consent preferences. iubenda's own
// `.iubenda-cs-preferences-link` binding is lost after Turbo swaps the page,
// so call its API on click; the link's href stays as a no-JS fallback.
export default class extends Controller {
  open (event) {
    const api = window._iub?.cs?.api
    if (!api?.openPreferences) return

    event.preventDefault()
    api.openPreferences()
  }
}
